(function () {
const unavailableText = '❌';
let clickInit = false; // Gardé pour compatibilité (inutilisé)

const style = document.createElement('style');
style.textContent = `
  .rapi-swatch-option.rapi-unavailable {
    cursor: not-allowed !important;
    pointer-events: none !important;
  }
  .rapi-swatch-option span {
    position: relative;
    display: block;
  }
  .rapi-swatch-option.rapi-unavailable span::after {
    content: '';
    position: absolute;
    inset: -2px;
    border-radius: 50%;
    box-shadow: 0 0 0 2px rgba(255, 0, 0, 0.85);
    background: linear-gradient(
      to bottom right,
      transparent calc(50% - 1.5px),
      rgba(255, 0, 0, 0.85) calc(50% - 1.5px),
      rgba(255, 0, 0, 0.85) calc(50% + 1.5px),
      transparent calc(50% + 1.5px)
    );
    pointer-events: none;
    z-index: 2;
  }
  .rapi-dropdown-content > div.rapi-unavailable {
    cursor: not-allowed !important;
    pointer-events: none !important;
    opacity: 0.5;
  }
  .rapi-dropdown-content > div.rapi-unavailable span:first-child {
    position: relative;
    display: inline-block;
  }
  .rapi-dropdown-content > div.rapi-unavailable span:first-child::after {
    content: '';
    position: absolute;
    inset: -2px;
    border-radius: 50%;
    box-shadow: 0 0 0 2px rgba(255, 1, 1, 0.85);
    background: linear-gradient(
      to bottom right,
      transparent calc(50% - 1.5px),
      rgba(252, 6, 6, 0.85) calc(50% - 1.5px),
      rgba(255, 0, 0, 0.85) calc(50% + 1.5px),
      transparent calc(50% + 1.5px)
    );
    pointer-events: none;
    z-index: 2;
  }
  .rapi-bundles__bar-variant-select option.rapi-unavailable {
    color: #999999;
    font-style: italic;
  }
`;
(document.head || document.documentElement).appendChild(style);

// ── Locale détectée une seule fois ───────────────────────────────────
const _localeMatch = window.location.pathname.match(/^\/([a-z]{2}(?:-[a-zA-Z]{2,4})?)(?=\/|$)/i);
const localePrefix = _localeMatch ? `/${_localeMatch[1]}` : '';

// ── Fetch lancé IMMÉDIATEMENT ─────────────────────────────────────────
const productCache = new Map();

function startPrefetch(handle) {
  if (!handle || productCache.has(handle)) return;
  const promise = fetch(`${localePrefix}/products/${handle}.js`, { priority: 'high' })
    .then(r => r.ok ? r.json() : null)
    .then(p => p?.variants || null)
    .catch(() => null);
  productCache.set(handle, promise);
}

async function getVariants(handle) {
  if (!productCache.has(handle)) startPrefetch(handle);
  return productCache.get(handle);
}

const earlyHandle = window.location.pathname.match(/\/products\/([^/?#]+)/)?.[1];
if (earlyHandle) startPrefetch(earlyHandle);

// ── Helpers ───────────────────────────────────────────────────────────
function findHandle(variantEl) {
  const pathWithoutLocale = window.location.pathname.replace(/^\/[a-z]{2}(?:-[a-zA-Z]{2,4})?(?=\/)/i, '');
  const pathHandle = pathWithoutLocale.match(/\/products\/([^/?#]+)/)?.[1];
  if (pathHandle) return pathHandle;


  let el = variantEl || document.body;
  while (el && el !== document.documentElement) {
    const d = el.dataset;
    if (d?.productHandle) return d.productHandle;
    if (d?.handle) return d.handle;
    if (d?.url) {
      const m = d.url.match(/\/products\/([^/?#]+)/);
      if (m) return m[1];
    }
    const attr = el.getAttribute('data-product-handle') || el.getAttribute('data-handle');
    if (attr) return attr;
    el = el.parentElement;
  }

  const link = variantEl?.closest('[data-url]')?.dataset?.url ||
               variantEl?.querySelector('a[href*="/products/"]')?.href ||
               document.querySelector('a[href*="/products/"]')?.href;
  if (link) {
    const m = link.match(/\/products\/([^/?#]+)/);
    if (m) return m[1];
  }

  if (window.ShopifyAnalytics?.meta?.product?.handle)
    return window.ShopifyAnalytics.meta.product.handle;
  if (window.meta?.product?.handle)
    return window.meta.product.handle;

  const ogUrl = document.querySelector('meta[property="og:url"]')?.content;
  if (ogUrl) {
    const m = ogUrl.match(/\/products\/([^/?#]+)/);
    if (m) return m[1];
  }

  for (const script of document.querySelectorAll('script[type="application/json"]')) {
    try {
      const data = JSON.parse(script.textContent);
      if (data?.product?.handle) return data.product.handle;
      if (data?.handle && data?.variants) return data.handle;
    } catch (_) {}
  }
  return null;
}

// ── Validation combo bundle ───────────────────────────────────────────
function variantsMatchUI(variantEl, variants) {
  const barVariants = variantEl.closest('.rapi-bundles__bar-variants');
  if (barVariants) {
    let sibling = barVariants.previousElementSibling;
    while (sibling) {
      if (sibling.classList.contains('rapi--royal-combo-bundle')) {
        const swatchTitles = [
          ...variantEl.querySelectorAll('.rapi-swatch-option span[title]')
        ].map(s => s.getAttribute('title')).filter(Boolean);
        if (swatchTitles.length === 0) return true;
        const allFetchedOptions = new Set(variants.flatMap(v => v.options || []));
        return !swatchTitles.some(title => !allFetchedOptions.has(title));
      }
      sibling = sibling.previousElementSibling;
    }
  }
  return true;
}

function getSelectedOptions(variantEl) {
  const wrapper = variantEl.querySelector('.rapi-bundles__bar-variant-selects');
  if (!wrapper) return [];
  const options = [];
  const seen = new Set();
  wrapper.querySelectorAll('select, .rapi-dropdown, input.rapi-select-value').forEach(el => {
    if (seen.has(el)) return;
    if (el.tagName === 'SELECT') {
      options.push(el.value); seen.add(el);
    } else if (el.classList.contains('rapi-dropdown')) {
      const hidden = el.querySelector('input.rapi-select-value');
      if (hidden) { options.push(hidden.value); seen.add(hidden); }
    } else if (el.tagName === 'INPUT' && el.classList.contains('rapi-select-value')) {
      if (!el.closest('.rapi-dropdown')) { options.push(el.value); seen.add(el); }
    }
  });
  return options;
}

function getSlots(wrapper) {
  return Array.from(wrapper.querySelectorAll('select, .rapi-dropdown, input.rapi-select-value'))
    .filter(el => {
      if (el.tagName === 'SELECT') return true;
      if (el.classList.contains('rapi-dropdown')) return true;
      if (el.tagName === 'INPUT' && el.classList.contains('rapi-select-value') && !el.closest('.rapi-dropdown')) return true;
      return false;
    });
}

function isUnavailable(variants, optionIndex, testValue, currentOptions) {
  return !variants.some(v =>
    v.available && v.options.every((vOpt, i) => {
      if (i === optionIndex) return vOpt === testValue;
      if (i < optionIndex && currentOptions[i] !== undefined) return vOpt === currentOptions[i]; // ← i < optionIndex
      return true;
    })
  );
}

function updateAvailability(variantEl, variants) {
  const wrapper = variantEl.querySelector('.rapi-bundles__bar-variant-selects');
  if (!wrapper) return;

  const currentOptions = getSelectedOptions(variantEl);
  const slots = getSlots(wrapper);

   wrapper.querySelectorAll('select').forEach(select => {
   const idx = slots.indexOf(select);
   Array.from(select.options).forEach(option => {
     const unavail = isUnavailable(variants, idx, option.value, currentOptions);
     option.classList.toggle('rapi-unavailable', unavail);
     option.disabled = unavail;
 
     const label = unavail
       ? `${option.value} \u274C`
       : option.value;
 
     if (option.text !== label) option.text = label;
     delete option.dataset.originalText;
   });
 });


  wrapper.querySelectorAll('.rapi-swatch-buttons').forEach(swatchGroup => {
    const hiddenInput = swatchGroup.previousElementSibling;
    const idx = hiddenInput?.classList.contains('rapi-select-value')
      ? slots.indexOf(hiddenInput) : 0;
    swatchGroup.querySelectorAll('.rapi-swatch-option').forEach(swatch => {
      const span = swatch.querySelector('span[title]');
      const value = span?.title;
      if (!value) return;
      swatch.classList.toggle('rapi-unavailable',
        isUnavailable(variants, idx, value, currentOptions));
    });
  });

  wrapper.querySelectorAll('.rapi-dropdown').forEach(dropdown => {
    const idx = slots.indexOf(dropdown);
    dropdown.querySelectorAll('.rapi-dropdown-content > div').forEach(option => {
      const span = option.querySelector('span:last-child');
      const value = span?.textContent?.trim();
      if (!value) return;
      option.classList.toggle('rapi-unavailable',
        isUnavailable(variants, idx, value, currentOptions));
    });
  });
}

// ── AUTO-SÉLECTION ────────────────────────────────────────────────────
function isCurrentSelectionAvailable(variantEl, variants) {
  const currentOptions = getSelectedOptions(variantEl);
  return variants.some(v =>
    v.available &&
    currentOptions.every((opt, i) => !opt || v.options[i] === opt)
  );
}

function autoSelectAvailable(variantEl, variants) {
  if (isCurrentSelectionAvailable(variantEl, variants)) return false;


  const firstAvailable = variants.find(v => v.available);
  if (!firstAvailable) return false;


  const wrapper = variantEl.querySelector('.rapi-bundles__bar-variant-selects');
  if (!wrapper) return false;


  const slots = getSlots(wrapper);


  slots.forEach((slot, i) => {
    const targetValue = firstAvailable.options[i];
    if (targetValue === undefined) return;


    if (slot.tagName === 'SELECT') {
      if (slot.value !== targetValue) {
        slot.value = targetValue;
        slot.dispatchEvent(new Event('change', { bubbles: true }));
      }
    } else if (slot.classList.contains('rapi-dropdown')) {
      const hidden = slot.querySelector('input.rapi-select-value');
      if (hidden && hidden.value !== targetValue) {
        hidden.value = targetValue;
        hidden.setAttribute('value', targetValue);
        hidden.dispatchEvent(new Event('change', { bubbles: true }));
      }
    } else if (slot.tagName === 'INPUT' && slot.classList.contains('rapi-select-value')) {
      if (slot.value !== targetValue) {
        slot.value = targetValue;
        slot.setAttribute('value', targetValue);
        slot.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  });


  return true;
}

function autoSelectSizeForColor(variantEl, variants) {
  const currentOptions = getSelectedOptions(variantEl);
  const selectedColor = currentOptions[0];
  if (!selectedColor) return;

  // Si la combo actuelle est déjà dispo, rien à faire
  const isAvailable = variants.some(v =>
    v.available && v.options.every((vOpt, i) => vOpt === currentOptions[i])
  );
  if (isAvailable) return;

  // Trouver la première variante dispo avec cette couleur
  const firstAvailable = variants.find(v =>
    v.available && v.options[0] === selectedColor
  );
  if (!firstAvailable) return;

  const wrapper = variantEl.querySelector('.rapi-bundles__bar-variant-selects');
  if (!wrapper) return;

  const slots = getSlots(wrapper);

  // Mettre à jour seulement les slots APRÈS l'index 0 (tailles, etc.)
  slots.forEach((slot, i) => {
    if (i === 0) return; // Ne pas toucher à la couleur
    const targetValue = firstAvailable.options[i];
    if (targetValue === undefined) return;

    if (slot.tagName === 'SELECT') {
      if (slot.value !== targetValue) {
        slot.value = targetValue;
        slot.dispatchEvent(new Event('change', { bubbles: true }));
      }
    } else if (slot.classList.contains('rapi-dropdown')) {
      const hidden = slot.querySelector('input.rapi-select-value');
      if (hidden && hidden.value !== targetValue) {
        hidden.value = targetValue;
        hidden.setAttribute('value', targetValue);
        hidden.dispatchEvent(new Event('change', { bubbles: true }));
      }
    } else if (slot.tagName === 'INPUT' && slot.classList.contains('rapi-select-value')) {
      if (slot.value !== targetValue) {
        slot.value = targetValue;
        slot.setAttribute('value', targetValue);
        slot.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  });
}

async function initVariantEl(variantEl) {
  if (variantEl._availabilityAttached) return;
  variantEl._availabilityAttached = true;


  const handle = findHandle(variantEl);
  if (!handle) return;


  startPrefetch(handle);


  const variants = await getVariants(handle);
  if (!variants) return;


  if (!variantsMatchUI(variantEl, variants)) return;


  const update = () => updateAvailability(variantEl, variants);


  let userHasInteracted = false;
  const onUserInteract = (e) => {
    if (e.isTrusted) userHasInteracted = true;
  };


  // 🎯 NOUVEAU : Surveillance UNIFIÉE ET OPTIMISÉE DE TOUS LES ÉLÉMENTS
  const interactiveElements = [
    // Selects natifs
    ...variantEl.querySelectorAll('select'),
    // Inputs cachés (dropdowns + autres)
    ...variantEl.querySelectorAll('input.rapi-select-value'),
    // Swatch options
    ...variantEl.querySelectorAll('.rapi-swatch-option'),
    // 👇 NOUVEAU : Boutons dropdown
    ...variantEl.querySelectorAll('.rapi-dropdown-button'),
    // 👇 NOUVEAU : Options dropdown
    ...variantEl.querySelectorAll('.rapi-dropdown-content-single-option')
  ];


  // User interaction detection
  interactiveElements.forEach(el => {
    el.addEventListener('click', onUserInteract);
    el.addEventListener('change', onUserInteract);
  });


  // Update après interaction (60ms)
  interactiveElements.forEach(el => {
  el.addEventListener('click', () => requestAnimationFrame(() => {
  autoSelectSizeForColor(variantEl, variants);
  update();
}));
  el.addEventListener('change', (e) => {
    if (e.isTrusted) {
      autoSelectSizeForColor(variantEl, variants);
      update();
    }
  });
});


  // MutationObserver sur inputs (déjà existant)
  variantEl.querySelectorAll('input.rapi-select-value').forEach(hidden => {
    new MutationObserver(update).observe(hidden, {
      attributes: true, attributeFilter: ['value'],
    });
  });


  // SUPPRIMÉ : window.addEventListener global (plus nécessaire !)


  autoSelectAvailable(variantEl, variants);
  update();


  [100, 300, 600, 1000, 1500, 2500].forEach(delay => {
    setTimeout(() => {
      if (userHasInteracted) return;
      autoSelectAvailable(variantEl, variants);
      update();
    }, delay);
  });


  const wrapper = variantEl.querySelector('.rapi-bundles__bar-variant-selects');
  if (wrapper) {
    const valueWatcher = new MutationObserver(() => {
      if (userHasInteracted) return;
      setTimeout(() => {
        if (userHasInteracted) return;
        autoSelectAvailable(variantEl, variants);
        update();
      }, 50);
    });


    wrapper.querySelectorAll('input.rapi-select-value').forEach(hidden => {
      valueWatcher.observe(hidden, {
        attributes: true,
        attributeFilter: ['value'],
      });
    });


    wrapper.querySelectorAll('select').forEach(select => {
      select.addEventListener('change', (e) => {
        if (e.isTrusted) return;
        if (userHasInteracted) return;
        setTimeout(() => {
          if (userHasInteracted) return;
          autoSelectAvailable(variantEl, variants);
          update();
        }, 50);
      });
    });
  }
}

function initAll() {
  document.querySelectorAll('.rapi-bundles__bar-variant').forEach(variantEl => {
    const handle = findHandle(variantEl);
    if (handle) startPrefetch(handle);
    initVariantEl(variantEl);
  });
}

new MutationObserver(mutations => {
  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      if (node.nodeType !== 1) continue;
      if (node.matches?.('.rapi-bundles__bar-variant')) initVariantEl(node);
      node.querySelectorAll?.('.rapi-bundles__bar-variant').forEach(initVariantEl);
    }
  }
}).observe(document.body, { childList: true, subtree: true });

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAll);
} else {
  initAll();
}

// ── UPSELL / FREE GIFT OOS ────────────────────────────────────────────
// Rapi keeps all .rapi-gift-upsell-wrapper elements in the DOM at all times
// and toggles display:none/block on the inner .rapi-gift-product-inline child
// when the user switches between bundle deals. We watch that style attribute
// so we can apply OOS marking every time the section becomes visible.

function initUpsellOOS() {
  var upsellHandle = findHandle(document.body);
  if (!upsellHandle) return;
  startPrefetch(upsellHandle);
  getVariants(upsellHandle).then(function(variants) {
    if (!variants) return;

    function attachListeners(upsellEl) {
      upsellEl.querySelectorAll('select, .rapi-dropdown-button, .rapi-dropdown-content-single-option').forEach(function(el) {
        el.addEventListener('click', function() { requestAnimationFrame(function() { updateAvailability(upsellEl, variants); }); });
        el.addEventListener('change', function() { updateAvailability(upsellEl, variants); });
      });
      upsellEl.querySelectorAll('input.rapi-select-value').forEach(function(hidden) {
        new MutationObserver(function() { updateAvailability(upsellEl, variants); })
          .observe(hidden, { attributes: true, attributeFilter: ['value'] });
      });
    }

    function applyToUpsell(upsellEl) {
      if (!upsellEl || !upsellEl.querySelector('.rapi-bundles__bar-variant-selects')) return;
      // Always re-apply OOS marks — Rapi replaces the inner DOM on every deal switch
      updateAvailability(upsellEl, variants);
      // Re-attach listeners to the fresh DOM nodes each time
      attachListeners(upsellEl);
    }

    function scanUpsells() {
      document.querySelectorAll('.rapi-gift-upsell-wrapper').forEach(applyToUpsell);
    }

    // Watch each wrapper for Rapi replacing the inner .rapi-bundles__bar-variant-selects block.
    // Debounced so it fires once after Rapi finishes its batch of DOM changes.
    document.querySelectorAll('.rapi-gift-upsell-wrapper').forEach(function(wrapperEl) {
      var debounceTimer;
      new MutationObserver(function(mutations) {
        // Only act on childList changes at the wrapper level (Rapi adding/removing the selects block)
        var relevant = mutations.some(function(m) {
          return m.type === 'childList' && m.target === wrapperEl;
        });
        if (!relevant) return;
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(function() { applyToUpsell(wrapperEl); }, 50);
      }).observe(wrapperEl, { childList: true });
    });

    // Watch .rapi-gift-product-inline style changes (deal switch show/hide)
    document.querySelectorAll('.rapi-gift-product-inline').forEach(function(inlineEl) {
      new MutationObserver(function() {
        scanUpsells();
      }).observe(inlineEl, { attributes: true, attributeFilter: ['style'] });
    });

    // Run immediately and retry at staggered intervals in case Rapi injects late
    scanUpsells();
    [100, 300, 600, 1000, 1500, 2500].forEach(function(delay) {
      setTimeout(scanUpsells, delay);
    });
  });
}

initUpsellOOS();


})();

